import { createTheme } from "@mui/material"

export const defaultTheme = createTheme({
  typography: {
    fontFamily: "Visby",
  },
})
